<nz-drawer
  [nzClosable]="false"
  [nzVisible]="isVisibleNotif"
  nzPlacement="right"
  (nzOnClose)="close()"
  [nzZIndex]="1000000"
  [nzWidth]="drawerWidth"
  [nzBodyStyle]="drawerBodyStyle"
>
  <ng-container *nzDrawerContent>
    <div class="mb-2">
      <div class="flex items-center justify-between">
        <nz-tabset
          class="notif-tabs flex-grow"
          [(nzSelectedIndex)]="selectedTabIndex"
        >
          <nz-tab [nzTitle]="notifTabTitle"></nz-tab>
          <nz-tab [nzTitle]="systemUpdateLogTabTitle"></nz-tab>
        </nz-tabset>

        <ng-template #notifTabTitle>
          <span>Notifications</span>
          <span *ngIf="unreadNotif.length > 0" class="notif-badge">{{ unreadNotif.length }}</span>
        </ng-template>
        <ng-template #systemUpdateLogTabTitle>
          <span>System Updates Log</span>
          <span *ngIf="unreadSystemUpdateLog.length > 0" class="notif-badge">{{ unreadSystemUpdateLog.length }}</span>
        </ng-template>
        <span
          class="text-lg text-gray-400 cursor-pointer p-1 ml-3 flex-shrink-0 transition-colors duration-200 hover:text-gray-700"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="close()"
        ></span>
      </div>

      <div class="flex items-center justify-between mt-3 mb-2">
        <span class="font-semibold text-sm text-gray-800">Newest</span>
        <button
          [disabled]="isMarkAllDisabled"
          class="btn-mark-all-read"
          (click)="handleMarkAllRead()"
        >
          Mark all as read
        </button>
      </div>
    </div>

    <!-- Tab: Notifications -->
    <div *ngIf="selectedTabIndex === 0" class="notif-tab-content">
      <div
        *ngIf="notification && notification.total > 0"
        class="flex flex-col gap-3 overflow-y-auto"
      >
        <ng-container
          *ngFor="let notif of notification.notifications; let i = index"
        >
          <nz-card class="p-3 mb-2" [ngClass]="notif.is_read ? '' : 'bg-[#FFECE9]'" nzHoverable (click)="readNotif(notif.id)">
            <div class="flex items-start mb-2 gap-2">
              <div
                class="w-[50px] h-[50px] min-w-[50px] flex justify-center items-center rounded-full flex-shrink-0 bg-gray-100 max-sm:w-10 max-sm:h-10 max-sm:min-w-[40px]"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/LP-Rajaongkir/apple-touch-icon.png"
                  alt="img"
                  width="25px"
                />
              </div>
              <div
                class="flex-1 min-w-0 flex flex-col justify-start items-start"
              >
                <div
                  class="w-full flex justify-between items-center flex-wrap gap-1 max-sm:flex-col max-sm:items-start"
                >
                  <span
                    class="font-medium text-base max-sm:text-sm"
                    >{{ notif.title }}</span
                  >
                  <span
                    class="text-xs text-gray-500 text-end max-sm:text-left max-sm:text-[11px]"
                  >
                    {{ notif.created_at | date : "EEEE, MMMM dd, yyyy" }}</span
                  >
                </div>
                <span class="break-words text-gray-500 mt-2 max-sm:text-[13px]">
                  {{ notif.message }}
                </span>

                <a routerLink="{{ actionSubsLink(notif.title) }}" (click)="closeDrawer()" class="text-[#626262] underline mt-3">
                  {{ actionSubsTitle(notif.title) }}
                </a>
              </div>
            </div>
          </nz-card>
        </ng-container>
      </div>

      <nz-empty
        *ngIf="!notification || notification.total === 0"
        [nzNotFoundContent]="contentTpl"
      >
        <ng-template #contentTpl>
          <span>No Notification</span>
        </ng-template>
      </nz-empty>
    </div>

    <!-- Tab: System Updates Log -->
    <div *ngIf="selectedTabIndex === 1" class="notif-tab-content">
      <div
        *ngIf="allSystemUpdateLogs.length > 0"
        #systemLogScrollContainer
        class="flex flex-col gap-3 system-log-scroll-container"
        (scroll)="onSystemLogScroll($event)"
      >
        <ng-container *ngFor="let log of allSystemUpdateLogs">
          <nz-card
            class="p-3 mb-2"
            [ngClass]="log.is_read ? '' : 'bg-[#FFECE9]'"
            nzHoverable
            (click)="readSysUpdateLog(log.id)"
          >
            <div class="flex items-start mb-2 gap-2">
              <div
                class="w-[50px] h-[50px] min-w-[50px] flex justify-center items-center rounded-full flex-shrink-0 bg-gray-100 max-sm:w-10 max-sm:h-10 max-sm:min-w-[40px]"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/LP-Rajaongkir/apple-touch-icon.png"
                  alt="img"
                  width="25px"
                />
              </div>
              <div
                class="flex-1 min-w-0 flex flex-col justify-start items-start"
              >
                <div
                  class="w-full flex justify-between items-center flex-wrap gap-1 max-sm:flex-col max-sm:items-start"
                >
                  <span class="font-medium text-base max-sm:text-sm">{{ log.title }}</span>
                  <span class="text-xs text-gray-500 text-end max-sm:text-left max-sm:text-[11px]">
                    {{ log.date | date : "EEEE, MMMM dd, yyyy" }}
                  </span>
                </div>
                <div
                  class="system-log-content mt-2"
                  [innerHTML]="formatContent(log.content)"
                ></div>
              </div>
            </div>
          </nz-card>
        </ng-container>

        <div *ngIf="systemLogLoading" class="flex justify-center py-3">
          <nz-spin nzSimple></nz-spin>
        </div>
      </div>

      <nz-empty
        *ngIf="allSystemUpdateLogs.length === 0 && !systemLogLoading"
        [nzNotFoundContent]="systemLogTpl"
      >
        <ng-template #systemLogTpl>
          <span>No System Updates</span>
        </ng-template>
      </nz-empty>

      <div *ngIf="allSystemUpdateLogs.length === 0 && systemLogLoading" class="flex justify-center py-5">
        <nz-spin nzSimple></nz-spin>
      </div>
    </div>
  </ng-container>
</nz-drawer>
